import api from "../../api/api";

const StreakFreezeModal = ({
  freezeCredits,
  onClose,
  onResolved,
}) => {

  const useFreeze = async () => {
    try {
      await api.post("/streak/use-freeze");
      onResolved();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const breakStreak = async () => {
    try {
      await api.post("/streak/break");
      onResolved();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="streak-modal-overlay">
      <div className="streak-modal">

        <h2>You missed a day 🔥</h2>
        <p>Your streak is at risk.</p>

        {freezeCredits > 0 ? (
          <p>You have {freezeCredits} freeze(s).</p>
        ) : (
          <p>No streak freezes available.</p>
        )}

        <div className="modal-actions">

          {freezeCredits > 0 && (
            <button id="use-freeze-btn" onClick={useFreeze}>
              Use Freeze
            </button>
          )}

          <button id="break-streak-btn" onClick={breakStreak}>
            Break Streak
          </button>

        </div>

      </div>
    </div>
  );
};

export default StreakFreezeModal;